import React from 'react';
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {Badge, Drawer, IconButton, Paper, Tab, Tabs} from "@mui/material";
import UnReadNotificationsInfinity from "./UnReadNotificationsInfinity";
import ReadNotificationsInfinity from "./ReadNotificationsInfinity";
import {withStyles} from "@mui/styles";
import {BellOff, BellRing, Bell} from "lucide-react";
import {translateKey} from "../../../../config/values";

class Notifications extends React.Component {
    state = {
        profileDrawerOpen:false,
        TabId: 0,
        countRN:0,
        countURN:0,
    };
    classes = this.props.classes;
    componentDidMount(){
        this.loadData();
        setInterval(this.loadData.bind(this), 5 * 60 * 1000);
    }

    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariables.url}/user/notifications/count`, config)
                .then(response => {
                    this.setState({
                        countURN: response.data[0],
                        countRN: response.data[1]-response.data[0],
                        countURNews: response.data[2],
                        loading:false
                    })
                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }
    }
    handleNotificationDrawer = () => {
        let count = this.state.countURN;
        let TabId= 0;
        if(count){
            TabId = 1
        }else {
            TabId = 0
        }
        this.setState({
            profileDrawerOpen:!this.state.profileDrawerOpen,
            TabId

        })
    };
    handleTabChange = (event, newValue) => {
        this.setState({
            TabId: newValue
        })
    };
    refresh(){
        console.log('here')
        this.loadData();
        this.setState({
            profileDrawerOpen:false,
        })
    }
    render(){
        let {profileDrawerOpen,TabId,countRN,countURN} = this.state;
        return (
            <>
                <IconButton
                    color='inherit'
                    onClick={this.handleNotificationDrawer}
                >
                    <Badge
                        badgeContent={countURN}
                        max={99}
                        color='primary'
                    >
                        {
                            countURN ?
                                <BellRing/>
                                :
                                <Bell/>
                        }


                    </Badge>
                </IconButton>
                <Drawer
                    classes={{
                        paper: this.classes.ProfileDrawer,
                    }}
                    anchor={this.props.locale === "en" ? "right" : "left"}
                    open={profileDrawerOpen}
                    onClose={this.handleNotificationDrawer.bind(this)}
                >
                    <Paper square className={this.classes.Tabroot}>
                        <Tabs
                            value={this.state.TabId}
                            onChange={this.handleTabChange}
                            variant="fullWidth"
                            indicatorColor="primary"
                            textColor="primary"
                            className={this.classes.tabHeader}
                        >
                            <Tab icon={<BellOff/>}  iconPosition="start" label={translateKey('readNotifications')}/>
                            <Tab icon={<BellRing/>} iconPosition="start" label={translateKey('unreadNotifications')} />
                        </Tabs>
                        {
                            TabId ? <UnReadNotificationsInfinity count={countURN}  refresh={this.refresh.bind(this)}/> : <ReadNotificationsInfinity count={countRN} refresh={this.refresh.bind(this)}/>
                        }
                    </Paper>
                </Drawer>
            </>
        );
    }

}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
});
export default withStyles(Styles)(connect(mstp)(Notifications));
